// SOARLIFE FERTILITY ROADMAP™ — KREYÒL AYISYEN (Haitian Creole)
// Mirrors roadmapContent.js structure exactly — same ids, keys, and shape.

export const EVALUATION = {
  id: "evaluation",
  title: "Evalyasyon Fetilite",
  intro:
    "Pifò klinik fetilite kòmanse ak tès yo anvan tretman. Lè w konprann rezilta ou yo, li ede w ansanm ak doktè w chwazi pi bon chemen an.",
  groups: [
    {
      label: "Tès pou fanm yo ka gen ladan",
      items: [
        "AMH (Òmòn Anti-Müllerian)",
        "FSH",
        "LH",
        "Estradiol",
        "Progesterone",
        "TSH",
        "Vitamin D",
        "Tès Maladi Enfeksyè",
        "Ekografi Vajinal",
        "HSG",
        "Sonogram ak Dlo Sale",
        "Tès Pòtè Jenetik",
      ],
    },
    {
      label: "Tès pou gason yo ka gen ladan",
      items: [
        "Analiz Espèm",
        "Testosterone",
        "Tès Òmòn",
        "Tès Maladi Enfeksyè",
        "Tès Pòtè Jenetik",
      ],
    },
  ],
  checklist: [
    { key: "eval:health-history", label: "Ranpli istwa sante w" },
    { key: "eval:upload-records", label: "Voye dosye medikal ou yo" },
    { key: "eval:upload-medications", label: "Voye lis medikaman ou yo" },
    { key: "eval:verify-insurance", label: "Verifye asirans ou" },
    { key: "eval:provider-questions", label: "Ajoute kesyon pou doktè a" },
  ],
};

export const AMH_EDUCATION = {
  id: "amh",
  title: "Konprann AMH",
  paragraphs: [
    "AMH vle di Anti-Müllerian Hormone (Òmòn Anti-Müllerian).",
    "AMH ede estime rezèv ovaryen an, sa vle di kantite ze ki rete nan ovè yo.",
    "AMH pa mezire kalite ze yo.",
  ],
  groups: [
    {
      label: "AMH ka ede doktè estime",
      items: ["Rezèv ovaryen", "Repons bay medikaman fetilite", "Planifikasyon IVF"],
    },
  ],
  notes: [
    { heading: "AMH wo", text: "Sa ka vle di gen plis folikil ki disponib." },
    { heading: "AMH ba", text: "Sa ka vle di rezèv ovaryen an diminye." },
    {
      heading: "Sonje",
      text: "Yon AMH ki ba pa vle di li enposib pou w ansent otomatikman.",
    },
  ],
  suggestedQuestions: [
    "Kijan AMH mwen an afekte tretman an?",
    "Èske m ta dwe konsidere konsèvasyon fetilite?",
    "Ki lòt tès yo rekòmande?",
  ],
};

export const PRE_TRANSFER = {
  id: "pre-transfer",
  title: "Prepare w pou Transfè Anbryon an",
  paragraphs: ["Anpil espesyalis fetilite evalye matris la anvan transfè a."],
  groups: [
    { label: "Tès yo ka gen ladan", items: ["Sonogram ak Dlo Sale", "Isteroskopi"] },
  ],
  notes: [
    {
      heading: "Kisa isteroskopi ye",
      text: "Yon pwosedi ki pèmèt doktè a gade anndan kavite matris la.",
    },
    {
      heading: "Objektif la ka pou jwenn",
      text: "Polip · Ti sikatriss · Fibròm ki afekte kavite matris la · Zòn enfalmasyon",
    },
  ],
  checklist: [
    { key: "transfer:review-meds", label: "Revize medikaman yo" },
    { key: "transfer:follow-instructions", label: "Swiv enstriksyon transfè yo" },
    { key: "transfer:confirm-date", label: "Konfime dat transfè a" },
    { key: "transfer:transportation", label: "Òganize transpò" },
    { key: "transfer:prep-checklist", label: "Ranpli lis preparasyon an" },
    { key: "transfer:support", label: "Pran sipò si w vle" },
  ],
};

export const BLOCKED_TUBES = {
  id: "blocked-tubes",
  title: "Konprann Twonp Falop ki Bloke",
  paragraphs: [],
  groups: [
    {
      label: "Ki sa ki lakòz twonp bloke? Koz posib yo gen ladan",
      items: ["Enfeksyon anvan", "Endometrioz", "Ti sikatriss", "Operasyon", "Hydrosalpinx"],
    },
  ],
  notes: [
    {
      heading: "Èske yo ka debloke twonp yo? Pafwa",
      text: "Yon doktè ka pale de operasyon laparoskopik pou eseye repare yo.",
    },
    {
      heading: "Sepandan",
      text: "Siksè pa garanti — rezilta yo depann de gravite ak kote blokaj la ye.",
    },
    {
      heading: "Etap kap swiv",
      text: "Gen pasyan doktè ka konseye konsidere IVF.",
    },
  ],
};

export const DONOR_EGG_EDU = {
  id: "donor-egg-edu",
  title: "Sant Edikasyon sou Ze Donè",
  paragraphs: [
    "Kòm fanm ap grandi nan laj, kalite ze ak nòmalite kromozomik yo diminye an jeneral.",
    "Sèvi ak ze donè se yon desizyon pèsonèl.",
  ],
  groups: [
    {
      label: "Poukisa doktè yo souvan pale de ze donè apre 44 an",
      items: [
        "To devlopman anbryon yo ka diminye",
        "To avòtman ka ogmante",
        "To siksè IVF ak pwòp ze ou souvan vin pi ba",
        "Ze donè ka ofri yon pi gwo chans pou ansent",
      ],
    },
  ],
  notes: [],
  soarlifeProvides: [
    "Edikasyon",
    "Sipò emosyonèl",
    "Preparasyon pou randevou",
    "Kesyon pou w diskite ak doktè w",
  ],
};

export const PREGNANCY_TESTING = {
  id: "pregnancy-testing",
  title: "Tès Gwosès & Tan Dite a",
  paragraphs: [],
  groups: [
    {
      label: "Apre IUI",
      items: ["Tès gwosès nan san fèt anvan pli piti 2 semèn apre"],
    },
    {
      label: "Apre transfè IVF",
      items: ["Tès gwosès nan san (Beta hCG) fèt selon pwotokòl klinik la"],
    },
    {
      label: "Pandan tan dite a, pòtal la ba w",
      items: [
        "Ankourajman chak jou",
        "Sipò byennèt emosyonèl",
        "Edikasyon ak AI",
        "Opsyon sipò ki gen enfimyè k ap gide",
      ],
    },
  ],
  notes: [],
};

export const PATHWAYS = [
  {
    id: "natural",
    title: "Eseye Fè Timoun Natirèlman",
    tagline: "Konprann sik ou ak fennèt fertil ou",
    whatIsIt: "Swivi sik natirèl san medikaman fetilite.",
    whatToExpect: [
      {
        label: "Premye mwa",
        items: ["Tès debaz yo", "Swivi ovilasyon"],
      },
      {
        label: "Chak mwa",
        items: ["Swivi fetilite", "Amelyore abitid lavi", "Edikasyon sou bon moman"],
      },
    ],
    doctorQuestions: [
      "Èske m ovile regilyèman?",
      "Èske m bezwen lòt tès?",
      "Èske patnè mwen ta dwe fè yon analiz espèm?",
      "Konbyen tan nou ta dwe kontinye eseye natirèlman?",
    ],
    steps: [
      {
        title: "Evalyasyon Fetilite",
        summary: "Tès debaz anvan tretman",
        details: ["Pifò klinik fetilite kòmanse ak tès yo anvan tretman."],
        education: ["evaluation", "amh"],
      },
      {
        title: "Swivi Ovilasyon",
        summary: "Aprann jan sik ou mache",
        details: [
          "Swivi ovilasyon chak sik — kit prediksyon ovilasyon ak siy sik yo ede w jwenn bon moman an.",
        ],
      },
      {
        title: "Fennèt Fertil la",
        summary: "Swiv jou yo kote konsepsyon posib",
        details: [
          "Swivi fennèt fertil la — an jeneral 5 jou anvan ovilasyon ak jou ovilasyon an menm.",
        ],
      },
      {
        title: "Rapò Entim Pwograme",
        summary: "Ozantou de ovilasyon",
        details: ["Rapò entim pwograme ozantou de ovilasyon bay pi bon chans natirèl la."],
      },
      {
        title: "Tès Gwosès",
        summary: "Ki lè e kijan pou w teste",
        details: ["Pifò tès yo fyab apati premye jou reg ou ki an reta."],
        education: ["pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "natural:track-cycles", label: "Swiv sik yo" },
      { key: "natural:track-ovulation", label: "Swiv ovilasyon" },
      { key: "natural:testing", label: "Fè tès fetilite yo" },
      { key: "natural:symptoms", label: "Note sentòm yo" },
    ],
  },
  {
    id: "ti",
    title: "Rapò Entim Pwograme (TI)",
    tagline: "Idantifye ovilasyon e pwograme fennèt fertil la",
    whatIsIt:
      "Rapò entim pwograme konsantre sou idantifye ovilasyon epi fè rapò entim pandan fennèt fertil la.",
    doctorQuestions: [
      "Èske m ovile regilyèman?",
      "Èske m bezwen lòt tès?",
      "Èske patnè mwen ta dwe fè yon analiz espèm?",
      "Konbyen tan nou ta dwe kontinye ak rapò pwograme?",
    ],
    steps: [
      {
        title: "Swivi Ovilasyon",
        summary: "Etap 1 nan liy chronolojik TI a",
        details: ["Idantifye ovilasyon ak swivi, kit, oswa swivi nan klinik."],
        education: ["evaluation"],
      },
      {
        title: "Fennèt Fertil la",
        summary: "Etap 2 nan liy chronolojik TI a",
        details: ["Doktè w ka konfime moman ovilasyon an ak swivi oswa tès laboratwa."],
      },
      {
        title: "Rapò Entim Pwograme",
        summary: "Etap 3 nan liy chronolojik TI a",
        details: ["Rapò entim la pwograme ozantou de fennèt fertil ki konfime a."],
      },
      {
        title: "Tès Gwosès",
        summary: "Etap 4 nan liy chronolojik TI a",
        details: ["Tès la fèt anvan pli piti de semèn apre ovilasyon."],
        education: ["pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "ti:track-cycles", label: "Swiv sik yo" },
      { key: "ti:track-ovulation", label: "Swiv ovilasyon" },
      { key: "ti:testing", label: "Fè tès fetilite yo" },
      { key: "ti:symptoms", label: "Note sentòm yo" },
    ],
  },
  {
    id: "medicated-ti",
    title: "Rapò Entim Pwograme ak Medikaman",
    tagline: "Sipò pou sik la ak medikaman fetilite",
    steps: [
      {
        title: "Debaz (Jou Sik 2-5)",
        summary: "Ekografi debaz + analiz san",
        details: ["Ekografi debaz", "Analiz san"],
        education: ["evaluation", "amh"],
      },
      {
        title: "Medikaman (Jou Sik 3-7)",
        summary: "Faz medikaman fetilite",
        details: [],
        medicationCards: [
          { name: "Clomid", desc: "Li estkmile ovilasyon." },
          { name: "Letrozole", desc: "Souvan preskri pou twoub ovilasyon tankou PCOS." },
          { name: "Piki Ovidrel (Trigger)", desc: "Li fikse moman ovilasyon an." },
        ],
      },
      {
        title: "Swivi (Jou Sik 10-14)",
        summary: "Ekografi swivi + tès òmòn",
        details: [
          "Ekografi swivi",
          "Swivi òmòn",
          "Rapèl otomatik pou medikaman ak ekografi voye pa imel anvan randevou ou yo.",
        ],
      },
      {
        title: "Piki Trigger",
        summary: "Ovidrel administre",
        details: ["Ovidrel administre pou fikse moman ovilasyon an avèk presizyon."],
      },
      {
        title: "Rapò Entim Pwograme",
        summary: "Dapre rekòmandasyon doktè a",
        details: ["Moman an swiv rekòmandasyon doktè w apre piki a."],
      },
      {
        title: "Tès Gwosès",
        summary: "Anvan pli piti de semèn apre",
        details: ["Klinik la ap di w egzakteman ki jou pou w teste."],
        education: ["pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "mti:baseline", label: "Fè vizit debaz la" },
      { key: "mti:meds", label: "Pran medikaman jan yo preskri a" },
      { key: "mti:monitoring", label: "Ale nan ekografi swivi yo" },
      { key: "mti:trigger", label: "Piki trigger fèt" },
    ],
    prepareChecklist: {
      title: "Sa pou w Prepare",
      items: [
        { key: "mti:reminders", label: "Rapèl medikaman aktive" },
        { key: "mti:calendar", label: "Kalandriye mete ajou" },
        { key: "mti:transport", label: "Transpò òganize" },
        { key: "mti:questions", label: "Kesyon anrejistre" },
      ],
    },
  },
  {
    id: "iui",
    title: "IUI (Enseminasyon Entràiterin)",
    tagline: "Vwayaj IUI a, etap pa etap",
    doctorQuestions: [
      "Ki lè m ta dwe atann ovilasyon?",
      "Konbyen folikil ki devlope?",
      "Ki chans siksè a?",
      "Kisa k ap pase si sik sa a pa mache?",
    ],
    steps: [
      {
        title: "Anvan w Kòmanse IUI",
        summary: "Kondisyon enpòtan",
        details: [
          "Omwen yon twonp falop dwe ouvè.",
          "Tès yo ka gen ladan: HSG, Sonogram ak Dlo Sale.",
        ],
        education: ["evaluation", "blocked-tubes"],
      },
      {
        title: "Randevou Debaz",
        summary: "Ekografi + analiz san",
        details: ["Ekografi", "Analiz san"],
      },
      {
        title: "Estimile Ovilasyon",
        summary: "Medikaman posib",
        details: [],
        medicationCards: [
          { name: "Letrozole", desc: "Souvan preskri pou sipòte ovilasyon." },
          { name: "Clomid", desc: "Li estkmile ovilasyon." },
          { name: "Medikaman enjektab", desc: "Yo sèvi ak yo lè yon repons pi fò nesesè." },
        ],
      },
      {
        title: "Randevou Swivi",
        summary: "Ekografi + tès òmòn",
        details: ["Ekografi yo", "Tès òmòn"],
      },
      {
        title: "Piki Trigger",
        summary: "Ovidrel",
        details: ["Ovidrel fikse moman ovilasyon an pou pwosedi a."],
      },
      {
        title: "Pwosedi IUI a",
        summary: "Jou enseminasyon an",
        details: ["Espèm ki prepare yo mete dirèkteman nan matris la."],
      },
      {
        title: "De Semèn Dite",
        summary: "Pòtal la sipòte w pandan tan sa a",
        details: [
          "Ankourajman chak jou",
          "Jounal sentòm (nan tchèk byennèt yo)",
          "Tchèk byennèt",
          "Sipò edikatif",
        ],
      },
      {
        title: "Tès Gwosès",
        summary: "Anvan pli piti 2 semèn apre IUI a",
        details: ["Tès gwosès nan san fèt anvan pli piti 2 semèn apre."],
        education: ["pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "iui:tubes", label: "Tès twonp yo fèt (HSG / sonogram dlo sale)" },
      { key: "iui:monitoring", label: "Ale nan randevou swivi yo" },
      { key: "iui:procedure", label: "Pwosedi IUI a fèt" },
      { key: "iui:wellness", label: "Tchèk byennèt chak jou pandan tan dite a" },
    ],
  },
  {
    id: "ivf",
    title: "IVF (Fekondasyon an Vitro)",
    tagline: "Vwayaj IVF konplè a nan sèt etap",
    steps: [
      {
        title: "Etap 1 · Tès & Preparasyon",
        summary: "Tès yo mande ka gen ladan",
        details: [
          "Tès òmòn",
          "AMH",
          "Vitamin D",
          "Tès maladi enfeksyè",
          "Tès jenetik",
          "Analiz espèm",
          "Evalyasyon ekografi",
        ],
        education: ["evaluation", "amh"],
      },
      {
        title: "Etap 2 · Estimilasyon Ovaryen",
        summary: "Medikaman enjektab chak jou ka gen ladan",
        details: [],
        medicationCards: [
          { name: "Gonal-F", desc: "Medikaman estimilasyon enjektab chak jou." },
          { name: "Follistim", desc: "Medikaman estimilasyon enjektab chak jou." },
          { name: "Menopur", desc: "Medikaman estimilasyon enjektab chak jou." },
        ],
        extraGroups: [
          {
            label: "Vizit swivi yo",
            items: ["Analiz san", "Ekografi", "Ajisteman medikaman"],
          },
        ],
      },
      {
        title: "Etap 3 · Piki Trigger",
        summary: "Final matirasyon ze yo anvan ransèvi",
        details: ["Piki trigger la fini matirasyon final ze yo anvan ransèvi a."],
      },
      {
        title: "Etap 4 · Ransèvi Ze",
        summary: "Pwosedi anba sedasyon",
        details: ["Ransèvi ze a se yon pwosedi ki fèt anba sedasyon pou rammase ze ki matirite yo."],
      },
      {
        title: "Etap 5 · Fekondasyon",
        summary: "Ze yo konbine ak espèm nan laboratwa",
        details: ["Ze yo ak espèm yo konbine nan yon laboratwa."],
      },
      {
        title: "Etap 6 · Devlopman Anbryon",
        summary: "Gade anbryon yo ap grandi",
        details: [
          "Jou 1 — Rapò Fekondasyon",
          "Jou 3 — Mizajou Devlopman",
          "Jou 5-7 — Devlopman Blastocyst",
        ],
      },
      {
        title: "Etap 7 · Tès Jenetik (Opsyonèl)",
        summary: "PGT ka diskite selon sitiyasyon endividyèl la",
        details: [
          "Avantaj — li tcheke anbryon yo pou anòmalite kromozomik anvan transfè.",
          "Limit — li pa yon garanti pou ansent; diskite presizyon ak rezilta yo ak doktè w.",
          "Kou — souvan faktire apa; verifye kouvèti asirans lan.",
          "Sèvi ak kreyatè kesyon an anba a pou w prepare kesyon pou doktè w.",
        ],
        education: ["pre-transfer", "pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "ivf:testing", label: "Fini tout tès debaz yo" },
      { key: "ivf:stimulation", label: "Ale nan swivi estimilasyon yo" },
      { key: "ivf:retrieval", label: "Ransèvi ze a fèt" },
      { key: "ivf:transfer-prep", label: "Lis preparasyon transfè a fini" },
    ],
  },
  {
    id: "egg-freezing",
    title: "Konsèvasyon Ze",
    tagline: "Prezève fetilite w nan pwòp moman ou",
    steps: [
      {
        title: "Evalyasyon Fetilite",
        summary: "Tès rezèv ak òmòn",
        details: ["AMH ak tès òmòn yo gide plan konsèvasyon ou."],
        education: ["evaluation", "amh"],
      },
      {
        title: "Estimilasyon Ovaryen",
        summary: "Medikaman ak swivi",
        details: ["Menm jan ak IVF — analiz san ak ekografi swiv kwasans folikil yo."],
      },
      {
        title: "Ransèvi Ze",
        summary: "Pwosedi anba sedasyon",
        details: ["Ransèvi ze a se yon pwosedi ki fèt anba sedasyon pou rammase ze ki matirite yo."],
      },
      {
        title: "Kongelasyon & Estokaj",
        summary: "Vitrifikasyon ak estokaj",
        details: ["Ze ki matirite yo konjele epi estoke pou itilizasyon nan lavni."],
      },
    ],
    checklist: [
      { key: "ef:testing", label: "Fè tès rezèv yo" },
      { key: "ef:retrieval", label: "Ransèvi ze a fèt" },
      { key: "ef:storage", label: "Plan estokaj la konfime" },
    ],
  },
  {
    id: "donor-egg",
    title: "IVF ak Ze Donè",
    tagline: "Konprann e navige konsepsyon ak donè",
    steps: [
      {
        title: "Sant Edikasyon sou Ze Donè",
        summary: "Edikasyon an premye",
        details: ["Sèvi ak ze donè se yon desizyon pèsonèl — aprann anvan w deside."],
        education: ["donor-egg-edu"],
      },
      {
        title: "Seleksyon Donè",
        summary: "Chwazi yon donè",
        details: ["Klinik ou oswa ajans lan gide matche, depistaj, ak etap legal yo."],
      },
      {
        title: "Preparasyon Matris",
        summary: "Prepare pou transfè a",
        details: ["Medikaman prepare mukoze matris la pou transfè a."],
        education: ["pre-transfer"],
      },
      {
        title: "Transfè Anbryon",
        summary: "Jou transfè a",
        details: ["Anbryon an transfere nan matris la nan yon pwosedi ki dire yon ti tan."],
      },
      {
        title: "Tès Gwosès",
        summary: "Jou rezilta a",
        details: ["Tès nan san an swiv pwotokòl klinik la apre tan dite a."],
        education: ["pregnancy-testing"],
      },
    ],
    checklist: [
      { key: "de:education", label: "Li edikasyon sou ze donè yo" },
      { key: "de:donor", label: "Donè chwazi" },
      { key: "de:prep", label: "Preparasyon matris la fini" },
    ],
  },
  {
    id: "exploring",
    title: "Eksplore Opsyon Fetilite yo",
    tagline: "Aprann an premye, deside lè w pare",
    steps: [
      {
        title: "Evalyasyon Fetilite",
        summary: "Konnen pwen depa ou",
        details: ["Tès yo ba w enfòmasyon — pa okenn obligasyon."],
        education: ["evaluation", "amh"],
      },
      {
        title: "Aprann Chemen yo",
        summary: "TI, IUI, IVF, konsèvasyon, opsyon donè",
        details: ["Eksplore chak chemen nan pwòp ritm ou nan roadmap sa a."],
        education: ["blocked-tubes"],
      },
      {
        title: "Kesyon Pou Doktè w",
        summary: "Prepare pou yon konsiltasyon",
        details: ["Sèvi ak kreyatè kesyon AI a pou w rive pare."],
      },
      {
        title: "Chwazi ak Sipò",
        summary: "Soarlife mache ave w",
        details: ["Yon avoka ki gen enfimyè k ap gide ka akonpanye w nan randevou yo vityèlman oswa an pèsòn."],
      },
    ],
    checklist: [
      { key: "ex:evaluation", label: "Fè evalyasyon fetilite a" },
      { key: "ex:questions", label: "Kreye kesyon pou doktè a" },
      { key: "ex:consult", label: "Pran yon konsiltasyon nouvo kliyan" },
    ],
  },
];

export const EDUCATION_SECTIONS = {
  evaluation: EVALUATION,
  amh: AMH_EDUCATION,
  "pre-transfer": PRE_TRANSFER,
  "blocked-tubes": BLOCKED_TUBES,
  "donor-egg-edu": DONOR_EGG_EDU,
  "pregnancy-testing": PREGNANCY_TESTING,
};

export const ACTION_CENTER = {
  supportOptions: [
    "Avoka Fetilite Vityèl",
    "Avoka Fetilite An Pèsòn nan Orlando",
    "Entèprèt Kreyòl Ayisyen",
    "Sesyon Sipò Fanmi",
  ],
  languages: ["English", "Kreyòl Ayisyen", "Français"],
};

export const UI = {
  portal: "Pòtal",
  tagline: "Sant navigasyon tretman ou",
  scoreTitle: "Nivo Preparasyon Vwayaj Ou",
  scoreParts: {
    history: "Istwa medikal ranpli",
    documents: "Dokiman voye",
    questions: "Kesyon prepare",
    appointments: "Randevou konfime",
    medications: "Medikaman swivi",
    wellness: "Tchèk byennèt fèt",
  },
  choosePathway: "Chwazi chemen ou an",
  whereAreYou: "Kote w rive nan vwayaj la",
  pickHint: "Chwazi chemen ki koresponn ak ou — ou ka chanje li nenpòt lè.",
  yourPathway: "Chemen ou",
  changePathway: "Chanje chemen",
  pathwayProgress: "Pwogrè chemen an",
  whatToExpectSteps: "Sa pou w atann — etap pa etap",
  checklistSuffix: "lis tchèk",
  whatIsIt: "Kisa li ye?",
  whatToExpect: "Sa pou w atann",
  doctorQuestions: "Kesyon pou w poze doktè w",
  generateQuestions: "Kreye kesyon pou doktè mwen",
  questionsForProvider: "Kesyon pou founisè swen w",
  couldNotGenerate: "Nou pa t kapab kreye kesyon yo kounye a — tanpri eseye ankò.",
  suggestedQuestionsLabel: "Kesyon sijere",
  actionCenter: "Sant Aksyon Soarlife",
  acExpect: "Sa pou w Atann",
  acQuestions: "Kesyon Pou Doktè Mwen",
  acAppointments: "Randevou Mwen yo",
  acReminders: "Rapèl Medikaman",
  acUpload: "Voye Dokiman",
  acAttend: "Vini Ave M (Attend With Me)",
  acAI: "Mande Soarlife AI",
  supportOptions: "Opsyon sipò",
  upcomingAppointments: "Randevou k ap vini yo",
  noAppointments:
    "Enfimyè w ap ajoute randevou isit la — rapèl preparasyon yo voye pa imel otomatikman.",
  automaticReminders: "Rapèl otomatik",
  remindersIntro: "Pou chak randevou nou voye lis preparasyon pa imel:",
  reminderMilestones: [
    ["30 jou", "Fòm admisyon · dosye · asirans"],
    ["14 jou", "Istwa sante · medikaman"],
    ["7 jou", "Dokiman · enstriksyon"],
    ["3 jou", "Kesyon pou doktè"],
    ["24 è", "Randevou · medikaman · transpò"],
  ],
  wellnessTitle: "Tchèk byennèt chak jou",
  moods: ["Anpil difisil", "Jou difisil", "OK", "Gen espwa", "Trè byen"],
  checkinPlaceholder: "Kijan w santi w jodi a? (nòt opsyonèl)",
  saveCheckin: "Anrejistre",
  checkinSaved: "Anrejistre — pran swen tèt ou",
  myQuestions: "Kesyon mwen pou doktè a",
  noQuestions:
    "Sèvi ak nenpòt bouton \"Kreye kesyon pou doktè mwen\" — kesyon ou yo ap rasanble isit la.",
  deniedTitle: "Roadmap la se pou kliyan yo",
  deniedBody:
    "Antre kòd aksè Soarlife ou nan Pòtal Kliyan an pou w debloke Roadmap Fetilite w.",
  deniedCta: "Ale nan Pòtal Kliyan an",
};
